import { render, staticRenderFns } from "./MemberDeleteModal.vue?vue&type=template&id=70a14b6e&"
import script from "./MemberDeleteModal.vue?vue&type=script&lang=js&"
export * from "./MemberDeleteModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports